import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Coordinate } from '../../models/heatmap/coordinate';
import { Scene } from 'src/app/models/Scene';

declare let h337: any;

@Component({
  selector: 'app-expanded-heatmap-modal',
  templateUrl: './expanded-heatmap-modal.page.html',
  styleUrls: ['./expanded-heatmap-modal.page.scss'],
})
export class ExpandedHeatmapModalPage implements OnInit {

  @Input('scene') scene: Scene;
  @Input('cameraTracking') cameraTracking: any[];

  public gradientCfg = {
    '0.15': '#6ad180',
    '0.25': '#7cd573',
    '0.35': '#90d865',
    '0.45': '#a4da57',
    '0.55': '#badc48',
    '0.65': '#c9cf35',
    '0.75': '#d6c226',
    '0.80': '#e2b41c',
    '0.85': '#e2961d',
    '0.90': '#dd7826',
    '0.95': '#d25c30',
    '1.0': '#c24039'
  };
  heatmap: any = null;
  coordinates: Array<Coordinate> = [];


  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    var max = this.generateCoordinates(581, 915);
    setTimeout(() => {
      var heatMapContainer = document.querySelector(".heatmap-expanded-container-" + this.scene.sceneId);
      const heatmapConfig = {
        container: document.querySelector(".heatmap-expanded-container-" + this.scene.sceneId),
        opacity: .8,
        radius: 7,
        visible: true,
        gradient: this.gradientCfg,
        backgroundColor: 'inherit'
      };
      console.log(heatmapConfig);
      this.heatmap = h337.create(heatmapConfig);
      this.heatmap.setData({ max: max, data: this.coordinates });
    }, 1000);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  isColouredBackground(scene: Scene) {
    if (scene != null && scene.sceneBackgroundFileType == "") {
      return true;
    }
    return false;
  }

  generateCoordinates(HEATMAP_HEIGHT, HEATMAP_WIDTH) {

    this.coordinates = [];

    var pi = Math.PI;
    this.cameraTracking.forEach(trackItem => {
      var rotx = trackItem.rotation.y * (180 / pi);
      var roty = trackItem.rotation.x * (180 / pi);

      roty += 90;
      rotx += 90;

      while (rotx < 0)
        rotx = rotx + 360;

      while (roty < 0)
        roty = roty + 180;

      while (rotx > 360)
        rotx = rotx - 360;

      while (roty > 180)
        roty = roty - 180;

      roty = 180 - roty;
      rotx = 360 - rotx;

      var width = HEATMAP_WIDTH / 360;
      var height = HEATMAP_HEIGHT / 180;

      var calcx = Math.round(rotx * width);
      var calcy = Math.round(roty * height);

      this.coordinates.push({ x: calcx, y: calcy, value: 1 });
    });
    var max = 0;
    this.coordinates.forEach(coord => {
      var len = this.coordinates.filter(x => x.x >= coord.x - 5 && x.x <= coord.x + 5 && x.y >= coord.y - 5 && x.y <= coord.y + 5).length;
      coord.value = len;
      if (max < len)
        max = len;
    });

    return max;
  }
}
